import styled from "styled-components";

const StyledScheduleLiveForm = styled.div`
	padding: 0px;
	.sb-schedule-live-form {
		&__upload {
			margin: 32px 0;
			&__input {
				margin-bottom: 8px;
			}
		}
		&__form {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			gap: 8px;
			&__button {
				width: 100%;
				max-width: unset;
				text-transform: none;
				height: 40px;
				margin-top: 16px;
				.sb-button__inner {
					font-size: 16px;
					white-space: nowrap;
				}
			}
		}
		&__actions {
			width: 100%;
			display: flex;
			flex-grow: 1;
			align-items: start;
			justify-content: space-between;
			flex-direction: row;
			gap: 18px;
		}
		.sb-workout-music-form__actions {
			display: flex;
		}
		.sb-form-text-area {
			textarea {
				border-radius: 0;
			}
		}
		.ant-form-item {
			margin-bottom: 16px;
		}
	}
`;

export default StyledScheduleLiveForm;

